export const navigationItems = [
  { id: 'dashboard', label: 'Central da Rodada', icon: '▣', accessKey: 'dashboard' },
  { id: 'championships', label: 'Campeonatos', icon: '◈', accessKey: 'championships' },
  { id: 'teams', label: 'Times', icon: '◉', accessKey: 'teams' },
  { id: 'players', label: 'Jogadores', icon: '◎', accessKey: 'players' },
  { id: 'matches', label: 'Jogos', icon: '◌', accessKey: 'matches' },
  { id: 'smsAlerts', label: 'Alertas SMS', icon: '✉', accessKey: 'matches', requiredRoles: ['super_admin', 'admin', 'organizer'] },
  { id: 'fields', label: 'Campos', icon: '◍', accessKey: 'matches' },
  { id: 'officiating', label: 'Arbitragem', icon: '◈', accessKey: 'matches' },
  { id: 'transmissions', label: 'Transmissões', icon: '◉', accessKey: 'matches' },
  { id: 'ranking', label: 'Ranking', icon: '★', accessKey: 'ranking' },
  { id: 'statistics', label: 'Estatísticas', icon: '✦', accessKey: 'statistics' },
  { id: 'products', label: 'Loja', icon: '◍', accessKey: 'products' },
  { id: 'coupons', label: 'Cupons', icon: '◇', accessKey: 'products' },
  { id: 'orders', label: 'Pedidos', icon: '◐', accessKey: 'orders' },
  { id: 'chat', label: 'Arquibancada Viva', icon: '◔', accessKey: 'chat' },
  { id: 'journal', label: 'Jornal Perifa', icon: '✦', accessKey: 'dashboard' },
  { id: 'moderation', label: 'Moderação', icon: '◒', accessKey: 'chat' },
  { id: 'users', label: 'Usuários', icon: '◑', accessKey: 'users' },
];
